import { Badge, Button, IconButton, Paper, Slide, Stack, Typography } from "@mui/material"
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart"
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong"
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart"
import { formatarBRL } from "@/lib/formato"

const SX_BOTAO = { flexShrink: 0, py: 2, px: 4, borderRadius: 3, textTransform: 'none' } as const

// "padrao" é a barra do totem de checkout (add-items-cart-bar): os dois totens têm que bater.
const MEDIDAS = {
    padrao: { total: 'h4', rotulo: 'h5', icone: 'large', respiroResumo: 1.5, respiroTextos: 0.5 },
    compacto: { total: 'h5', rotulo: 'h6', icone: 'medium', respiroResumo: 2, respiroTextos: 0 },
} as const

interface RodapeCarrinhoProps {
    totalItens: number
    subtotal: number
    aoAbrirCarrinho: () => void
    aoFinalizar: () => void
    compacto?: boolean
}

export function RodapeCarrinho({ totalItens, subtotal, aoAbrirCarrinho, aoFinalizar, compacto = false }: RodapeCarrinhoProps): JSX.Element {
    const medidas = compacto ? MEDIDAS.compacto : MEDIDAS.padrao

    return (
        <Slide direction="up" in={totalItens > 0} mountOnEnter unmountOnExit timeout={300}>
            <Paper
                elevation={0}
                square
                sx={{
                    flexShrink: 0,
                    px: 2,
                    pt: 1.5,
                    pb: 'calc(12px + env(safe-area-inset-bottom))',
                    borderTop: 1,
                    borderColor: 'divider',
                }}
            >
                <Stack direction="row" useFlexGap sx={{ flexWrap: 'wrap', alignItems: 'center', columnGap: 2, rowGap: 1.5 }}>
                    <Stack direction="row" useFlexGap spacing={medidas.respiroResumo} sx={{ flexShrink: 0, alignItems: 'center' }}>
                        {/* O enchimento aumenta a área de toque e a margem negativa o desconta: o ícone não sai do lugar. */}
                        <IconButton aria-label="Abrir carrinho" onClick={aoAbrirCarrinho} sx={{ p: 1, m: -1 }}>
                            <Badge badgeContent={totalItens} color="primary">
                                <ShoppingCartIcon fontSize="large" color="primary" />
                            </Badge>
                        </IconButton>

                        <Stack spacing={medidas.respiroTextos}>
                            <Typography variant={medidas.total} color="success.main" sx={{ fontWeight: 'bold' }}>
                                Total: {formatarBRL(subtotal)}
                            </Typography>

                            <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 'bold' }}>
                                {totalItens} {totalItens === 1 ? 'item' : 'itens'}
                            </Typography>
                        </Stack>
                    </Stack>

                    <Stack direction="row" spacing={2} sx={{ ml: 'auto' }}>
                        <Button variant="outlined" color="primary" onClick={aoAbrirCarrinho} sx={SX_BOTAO}>
                            <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center' }}>
                                <ReceiptLongIcon fontSize={medidas.icone} />

                                <Typography variant={medidas.rotulo} sx={{ fontWeight: 'bold' }}>
                                    Ver carrinho
                                </Typography>
                            </Stack>
                        </Button>

                        <Button variant="contained" color="primary" onClick={aoFinalizar} sx={SX_BOTAO}>
                            <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center' }}>
                                <AddShoppingCartIcon fontSize={medidas.icone} />

                                <Typography variant={medidas.rotulo} sx={{ fontWeight: 'bold' }}>
                                    Finalizar pedido
                                </Typography>
                            </Stack>
                        </Button>
                    </Stack>
                </Stack>
            </Paper>
        </Slide>
    )
}
